import React from 'react';
import { IMAGE_URL } from '../../../Api/commonAPI';

const SectionD = ({ selectedBankData, annuityScheme, annuityFrequency }) => {

  return (
    <div className="section-container">
      <div className="card shadow-sm">
        <div className="card-body p-4">
          <div className="row g-4">
            {/* Annuity Service Provider */}
            <div className="col-md-4">
              <label className="form-label" style={{ fontSize: '0.875rem', color: '#6c757d', marginBottom: '0.75rem', display: 'block' }}>
                Annuity Service Provider
              </label>
              {selectedBankData ? (
                <div>
                  {selectedBankData.BankLogo && (
                    <div className="mb-2">
                      <img 
                        src={`${IMAGE_URL}${selectedBankData.BankLogo}`}
                        alt={selectedBankData.BankName}
                        style={{ 
                          height: '40px', 
                          width: 'auto',
                          maxWidth: '150px',
                          objectFit: 'contain'
                        }}
                      />
                    </div>
                  )}
                  <div style={{ fontSize: '1.1rem', fontWeight: '600', color: '#28a745' }}>
                    {selectedBankData.BankName}
                  </div>
                  {/* {selectedBankData.BankPensionData?.[0] && (
                    <div className="mt-2">
                      <div style={{ fontSize: '0.9rem', color: '#333', fontWeight: '600' }}>
                        Amount: ₹ {selectedBankData.BankPensionData[0].Amount}
                      </div>
                      <div style={{ fontSize: '0.85rem', color: '#28a745', fontWeight: '600' }}>
                        Rate: {selectedBankData.BankPensionData[0].PensionPer}%
                      </div>
                    </div>
                  )} */}
                </div>
              ) : (
                <div style={{ fontSize: '1rem', fontWeight: '500', color: '#dc3545', fontStyle: 'italic' }}>
                  Not Selected
                </div>
              )}
            </div>

            {/* Annuity Scheme */}
            <div className="col-md-4">
              <label className="form-label" style={{ fontSize: '0.875rem', color: '#6c757d', marginBottom: '0.75rem', display: 'block' }}>
                Annuity Scheme
              </label>
              <div style={{ fontSize: '1.1rem', fontWeight: '600', color: annuityScheme ? '#28a745' : '#dc3545', fontStyle: annuityScheme ? 'normal' : 'italic' }}>
                {annuityScheme || 'Not Selected'}
              </div>
            </div>

            {/* Annuity Frequency */}
            <div className="col-md-4">
              <label className="form-label" style={{ fontSize: '0.875rem', color: '#6c757d', marginBottom: '0.75rem', display: 'block' }}>
                Annuity Frequency
              </label>
              <div style={{ fontSize: '1.1rem', fontWeight: '600', color: annuityFrequency ? '#28a745' : '#dc3545', fontStyle: annuityFrequency ? 'normal' : 'italic' }}>
                {annuityFrequency || 'Not Selected'}
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default SectionD;

